import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AccountService } from '../../../../Services/Accounts/account.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-profit-loss2',
  imports: [CommonModule],
  templateUrl: './profit-loss2.component.html',
  styleUrl: './profit-loss2.component.css'
})
export class ProfitLoss2Component implements OnInit, OnChanges {
  @Input() filters: any;

  data: any = {
    trading_account: {
      expenditure: [],
      revenue: [],
      gross_profit: 0,
      gross_loss: 0,
      total_expenditure: 0,
      total_revenue: 0
    },
    profit_loss_account: {
      expenditure: [],
      revenue: [],
      net_profit: 0,
      net_loss: 0,
      total_expenditure: 0,
      total_revenue: 0
    },
    capital_account: {
      expenditure: [],
      revenue: [],
      total_expenditure: 0,
      total_revenue: 0
    }
  };

  constructor(private accountService: AccountService) { }

  ngOnInit(): void {
    if (this.filters) {
      this.fetchData();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filters'] && !changes['filters'].firstChange) {
      this.fetchData();
    }
  }

  fetchData() {
    this.accountService.getProfitLoss(this.filters).subscribe({
      next: (res: any) => {
        this.data = res.data;
      }
    });
  }

  getRows(exp: any[], rev: any[]) {
    const max = Math.max(exp.length, rev.length);
    const rows = [];
    for (let i = 0; i < max; i++) {
      rows.push({
        exp: exp[i] || null,
        rev: rev[i] || null
      });
    }
    return rows;
  }
}
